import { render, staticRenderFns } from "./Thead.vue?vue&type=template&id=32521b87"
import script from "./Thead.vue?vue&type=script&lang=js"
export * from "./Thead.vue?vue&type=script&lang=js"
import style0 from "./Thead.vue?vue&type=style&index=0&id=32521b87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports